import React from "react";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import { ShareBookingIvr } from "./ShareBookingIvr";
import { PhoneToCnpBookingDetails } from "../PhoneToCnpEntities";
import "./ShareTripDialog.scss";

interface ShareTripDialogWrapperProps {
    open: boolean;
    onClose: () => void;
    booking: PhoneToCnpBookingDetails;
}

export const ShareTripDialogWrapper: React.FC<ShareTripDialogWrapperProps> = ({ open, onClose, booking }) => {
    return (
        <Dialog 
            open={open} 
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            className="share-trip-dialog"
        >
            <DialogTitle className="dialog-title">
                <span>Share trip</span>
                <button onClick={onClose} className="close-button" aria-label="close">
                    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.7292 5.12031L14.5542 3.94531L9.89583 8.60365L5.2375 3.94531L4.0625 5.12031L8.72083 9.77865L4.0625 14.437L5.2375 15.612L9.89583 10.9536L14.5542 15.612L15.7292 14.437L11.0708 9.77865L15.7292 5.12031Z" fill="#212121"/>
                    </svg>
                </button>
            </DialogTitle>
            <DialogContent sx={{ padding: "0", overflow: "hidden" }}>
                <ShareBookingIvr 
                    booking={booking} 
                    onClose={onClose} 
                />
            </DialogContent>
        </Dialog>
    );
};
